var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.5V25.625C27.5 24.6304 27.1049 23.6766 26.4016 22.9734C25.6984 22.2701 24.7446 21.875 23.75 21.875H16.25C15.2554 21.875 14.3016 22.2701 13.5983 22.9734C12.8951 23.6766 12.5 24.6304 12.5 25.625V27.5",
    fill: "#2D4993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C22.0711 20 23.75 18.3211 23.75 16.25C23.75 14.1789 22.0711 12.5 20 12.5C17.9289 12.5 16.25 14.1789 16.25 16.25C16.25 18.3211 17.9289 20 20 20Z",
    fill: "#2D4993"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryUser);
export default __webpack_public_path__ + "static/media/summaryUser.c5e04c9975c5fc619f99f693273b05bc.svg";
export { ForwardRef as ReactComponent };